module.exports = __webpack_public_path__ + "img/点击查看数字博物馆.png";